import gql from "graphql-tag";

const LOGIN = gql`
    mutation Public_LoginQuery(
        $username: String!
        $password: String!
        $token: String
    ) {
        auth: login(username: $username, password: $password, token: $token) {
            __typename

            ... on LoginSuccess {
                accessToken
                refreshToken
            }

            ... on LoginFailed {
                message
            }
        }
    }
`;

const ROTATE_TOKENS = gql`
    mutation Public_RotateTokensQuery($refreshToken: String!) {
        auth: rotateTokens(refreshToken: $refreshToken) {
            __typename

            ... on RotateTokensSuccess {
                accessToken
                refreshToken
            }

            ... on RotateTokensFailed {
                message
            }
        }
    }
`;

const GET_AUTH_TOKENS = gql`
    query Public_GetCurrentAuthQuery {
        auth @client {
            accessToken {
                ...Token
            }
            refreshToken {
                ...Token
            }
        }
    }

    fragment Token on Token {
        exp
        first_name
        is_admin
        last_name
        raw
        requires_2fa_setup
        switched_from
        token_type
        user_id
        username
    }
`;

const SWITCH_USER = gql`
    mutation SwitchUser($refreshToken: String!, $toUser: Int!) {
        auth: switchUser(refreshToken: $refreshToken, toUser: $toUser) {
            __typename

            ... on SwitchUserSuccess {
                accessToken
                refreshToken
            }

            ... on SwitchUserFailed {
                message
            }
        }
    }
`;

const HOOK = gql`
    query Hook($hookType: Int) {
        clientConfig {
            hooks(hookType: $hookType) {
                label
                link
            }
        }
    }
`;

const ENABLED_FEATURES = gql`
    query EnabledFeatures {
        clientConfig {
            enabledFeatures
        }
    }
`;

const queries = {
    LOGIN,
    ROTATE_TOKENS,
    GET_AUTH_TOKENS,
    SWITCH_USER,
    HOOK,
    ENABLED_FEATURES,
};

export default queries;
